import { Link } from 'react-router-dom';

const ENTRIES = [
  {
    to: '/category/works',
    icon: 'ri-film-line',
    title: '影视作品',
    desc: '完整收录电影与电视剧作品，支持按类型、年份筛选。',
    tone: 'primary',
  },
  {
    to: '/category/news',
    icon: 'ri-newspaper-line',
    title: '新闻动态',
    desc: '活动资讯、媒体专访与作品动态，第一时间了解近况。',
    tone: 'accent',
  },
  {
    to: '/profile',
    icon: 'ri-user-star-line',
    title: '个人简介',
    desc: '出生资料、职业经历、代表作品与获奖情况一览。',
    tone: 'secondary',
  },
];

const TONE_CLASS: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function CategoryEntry() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-xs tracking-[0.25em] text-accent-600">EXPLORE</span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">快速进入</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            三个入口，带你从不同角度认识小仓优子。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {ENTRIES.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group p-6 md:p-7 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <span className={`w-12 h-12 rounded-lg flex items-center justify-center ${TONE_CLASS[entry.tone]}`}>
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mt-5 group-hover:text-primary-600 transition-colors">
                {entry.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mt-3">{entry.desc}</p>
              <span className="inline-flex items-center gap-1 text-sm text-accent-600 mt-5">
                前往查看
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}